const EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const PASSWORD = /^(?=.*?[A-Za-z])(?=.*?\d)(?=.*[$@!%*?&])[^\s]{8,}$/;
const SPECIAL_CHARACTER = /^[^*|":<>[\]{}`\\()'!.;@&#$]+$/;
const PHONE_NUMBER = /^((?!000)\d{3}|[1-9]\d{2})[-\s.]?\d{3}[-\s.]?\d{4,}$/im;
const PINCODE = /^(\d{6})$/;
const FLOAT_NUMBER = /^\d+(\.\d{1,2})?$/;
const INT_NUMBER = /^\d{1,2}$/;
const STRING_CHARACTER = /^([a-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/i;
const NOT_NUMBER = /^\D+$/;
/** HTML tag sequences; used when normalizing rich text to plain string (e.g. JSON-LD FAQ `Answer.text`). */
const STRIP_HTML_TAGS = /<[^>]*>?/gm;
const NEWLINE = /\n/g;
const COLLAPSE_WHITESPACE = /\s{2,}/g;
/** CDN / URL path: strip leading slashes from relative paths. */
const LEADING_SLASHES = /^\/+/;
/** CDN image path: strip optional `images/` prefix when normalizing keys. */
const LEADING_IMAGES_PREFIX = /^images\//;
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    EMAIL,
    PASSWORD,
    SPECIAL_CHARACTER,
    PHONE_NUMBER,
    PINCODE,
    FLOAT_NUMBER,
    INT_NUMBER,
    STRING_CHARACTER,
    NOT_NUMBER,
    STRIP_HTML_TAGS,
    NEWLINE,
    COLLAPSE_WHITESPACE,
    LEADING_SLASHES,
    LEADING_IMAGES_PREFIX
};
